import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Prevent duplicate exchanges across component unmounts/remounts or StrictMode double-effects
const globalProcessedSessions = new Set();

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      toast.error("Authentication failed: No session ID found");
      navigate("/login", { replace: true });
      return;
    }

    if (globalProcessedSessions.has(sessionId)) {
      return; // Already processed or in-progress
    }
    globalProcessedSessions.add(sessionId);

    api.post("/auth/google-session", { session_id: sessionId })
      .then(async (r) => {
        if (r.data?.token) {
          localStorage.setItem("rtrl_token", r.data.token);
        }
        await refresh();
        toast.success("Successfully authenticated with Google!");
        const role = r.data?.role;
        if (role === "admin") navigate("/admin", { replace: true });
        else if (role === "syndicate_owner" || role === "gm") navigate("/team-admin", { replace: true });
        else navigate("/profile", { replace: true });
      })
      .catch((err) => {
        console.error("Session exchange error:", err);
        toast.error("Failed to authenticate session with Google");
        navigate("/login", { replace: true });
      });
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-void text-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rtrl-red mx-auto mb-4"></div>
        <p className="font-display uppercase tracking-widest text-lg text-rtrl-silver">Establishing Galactic Uplink…</p>
      </div>
    </div>
  );
}